import { useGetAiTokenCredits } from '@repo/api-codegen';

export function useInvoiceHistory() {
	const { data: creditsData } = useGetAiTokenCredits({});

	const formatCurrency = (amount: number) =>
		new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		}).format(amount);

	const getStatusBadgeVariant = (status: string) => {
		switch (status?.toLowerCase()) {
			case 'paid':
			case 'succeeded':
				return 'success';
			case 'pending':
				return 'attention';
			case 'failed':
			case 'canceled':
				return 'critical';
			default:
				return 'default';
		}
	};

	const formatDate = (dateString: string) => {
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		});
	};

	const handleViewInvoice = (invoiceUrl: string | null) => {
		if (invoiceUrl) {
			window.open(invoiceUrl, '_blank');
		}
	};

	return {
		creditsData,
		formatCurrency,
		getStatusBadgeVariant,
		formatDate,
		handleViewInvoice,
	};
}
